module.exports = __webpack_public_path__ + "img/xbox.d1fcc2e6.svg";